var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.74568 10.9088C7.40417 10.977 7.05109 10.9595 6.71796 10.858C6.38484 10.7565 6.08203 10.5741 5.83659 10.327L3.63659 8.05428C3.34358 7.76582 3.11089 7.42195 2.95206 7.04269C2.79322 6.66343 2.71143 6.25637 2.71143 5.84519C2.71143 5.43402 2.79322 5.02695 2.95206 4.64769C3.11089 4.26844 3.34358 3.92456 3.63659 3.6361V3.6361C3.92505 3.34309 4.26892 3.1104 4.64818 2.95157C5.02744 2.79273 5.43451 2.71094 5.84568 2.71094C6.25685 2.71094 6.66392 2.79273 7.04318 2.95157C7.42244 3.1104 7.76631 3.34309 8.05477 3.6361L10.2911 5.87246C10.5347 6.10596 10.7181 6.39494 10.8258 6.71472C10.9334 7.03449 10.9621 7.37557 10.9093 7.70883M7.27295 7.27246L12.7275 12.727L7.27295 7.27246ZM12.182 9.09065C12.5265 9.0334 12.8797 9.05966 13.2119 9.16723C13.5441 9.27481 13.8456 9.46054 14.0911 9.70883L16.3639 11.9997C16.939 12.5802 17.2617 13.3644 17.2617 14.1816C17.2617 14.9987 16.939 15.7829 16.3639 16.3634C15.783 16.9413 14.9969 17.2657 14.1775 17.2657C13.3581 17.2657 12.572 16.9413 11.9911 16.3634L9.7275 14.0906C9.47884 13.8506 9.2913 13.5545 9.18058 13.2271C9.06987 12.8997 9.0392 12.5505 9.09113 12.2088L12.182 9.09065Z",
    stroke: "#484964",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.7dce67d578c964226e19d91e7a3ea6b1.svg";
export { ForwardRef as ReactComponent };